export default "__VITE_ASSET__a6jU2kJC__"